module.exports = __webpack_public_path__ + "static/media/5.3167f19a.JPG";